import React, { HTMLAttributes } from 'react';

export interface ImageAvatarProps extends HTMLAttributes<HTMLDivElement> {
  size?: string;
  sizeStyles?: string;
  imageUrl: string;
}

export const ImageAvatar = ({
  className,
  size,
  sizeStyles,
  imageUrl,
  ...rest
}: ImageAvatarProps) => {
  return (
    <div
      className={`${sizeStyles} overflow-hidden ${className || ''} `}
      // size={size || ''}
      {...rest}
    >
      <img
        className="rounded-full object-scale-down"
        src={imageUrl}
        sizes={size}
        alt="profile-img"
      />
    </div>
  );
};
